import SlimSelect from 'slim-select'

const selects = document.querySelectorAll('.slimSelect');
const interest_select = document.getElementById('interested_select');

// wetlab
if (selects) {
	selects.forEach((selectElement) => {
	  new SlimSelect({
	    select: selectElement,
	    settings: {
    		showSearch: false,
    	},
		events: {
		  afterChange: (newVal) => {
		    if (newVal.length == 1) {
		    	if (newVal[0]['value'] === 'No') {
		    		interest_select.style.display = 'block';
		    	}
		    } else {
		    	// hide interested block
		    	interest_select.style.display = 'none';
		    }
		  }
		},
	  })
	})
}